export const WELLPASS_REGISTER_DEADLINE = 'wellpass-register-deadline';
export const WELLPASS_REGISTERED_AT = 'wellpass-registered-at';
